import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import TaskInbox from "./pages/TaskInbox";
import Insights from "./pages/Insights";
import Connections from "./pages/Connections";
import CalendarPage from "./pages/Calendar";
import Privacy from "./pages/Privacy";
import AdminDB from "./pages/AdminDB";
import Admin from "./pages/Admin";
import Invite from "./pages/Invite";
import Assistant from "./pages/Assistant";
import Agents from "./pages/Agents";
import AuthCallback from "./components/AuthCallback";
import InstallPrompt from "./components/InstallPrompt";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  // This prevents race conditions with auth checks
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/inbox" element={<TaskInbox />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/connections" element={<Connections />} />
      <Route path="/calendar" element={<CalendarPage />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/admin/db" element={<AdminDB />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/invite/:token" element={<Invite />} />
      <Route path="/assistant" element={<Assistant />} />
      <Route path="/agents" element={<Agents />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <InstallPrompt />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
